import React, { Component } from "react";
import "./FilterSection.css";

import rightChevronSVG from "./assets/filter-right-arrow.svg";
import downChevronSVG from "./assets/filter-down-arrow.svg";

import Switch from "./Switch";

const rightChevron = (
  <span className="filter-section-icon">
    <img src={rightChevronSVG} alt="right arrow" />
  </span>
);
const downChevron = (
  <span className="filter-section-icon">
    <img src={downChevronSVG} alt="down arrow" />
  </span>
);

class FilterSection extends Component {
  state = {
    showItems: false
  };
  handleLabelClick = e => {
    this.setState(({ showItems }) => ({ showItems: !showItems }));
  };
  render() {
    const { items, label, chosenItems, toggleItem, image } = this.props,
      { showItems } = this.state,
      itemsJSX = items.map(el => {
        const { title } = el,
          selected = chosenItems.includes(title);
        return (
          <div
            className="filter-section-option"
            key={title}
            onClick={toggleItem(title)}
          >
            <Switch on={selected} />
            <span className="filter-section-option-text">{title}</span>
          </div>
        );
      }),
      imgJSX = (
        <span className="filter-section-icon-image">
          <img src={image} alt="label" />
        </span>
      );
    return (
      <div className="filter-section">
        <div className="filter-section-heading" onClick={this.handleLabelClick}>
          {showItems ? downChevron : rightChevron} {imgJSX} {label}
        </div>
        {showItems && itemsJSX}
      </div>
    );
  }
}

export default FilterSection;
